var map = {
	"./432-ai.png": 10873,
	"./book.png": 2308,
	"./box.png": 59976,
	"./croppedchat.gif": 61483,
	"./dashboard.png": 68260,
	"./dot.png": 82894,
	"./get_started_bg.png": 73075,
	"./googleMeet.png": 70083,
	"./liveChat.gif": 62220,
	"./login.png": 91636,
	"./mobile.png": 28581,
	"./triangle.png": 21199,
	"./video_icon.png": 30860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65563;